// Exportação da visão em lista de Pipelines. Sem dependências: CSV e JSON são
// nativos, "Excel" é uma tabela HTML salva como .xls (abre direto no Excel) e
// "PDF" abre o diálogo de impressão do navegador ("Salvar como PDF").

const STATUS_LABEL = { aberto: 'Aberto', ganho: 'Ganho', perdido: 'Perdido' }

const dateOnly = (value) => {
  if (!value) return ''
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00` : value)
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR')
}

const EXPORT_COLUMNS = [
  { key: 'titulo', label: 'Título', get: (d) => d.titulo || '' },
  { key: 'valor', label: 'Valor', get: (d) => Number(d.valor) || 0 },
  { key: 'empresa', label: 'Empresa', get: (d) => d.company_name || '' },
  { key: 'contato', label: 'Pessoa de contato', get: (d) => d.primary_lead || '' },
  { key: 'origem', label: 'Origem', get: (d) => d.primary_lead_origem || '' },
  { key: 'proxima_atividade', label: 'Próxima atividade em', get: (d) => dateOnly(d.next_activity_at) },
  { key: 'etapa', label: 'Status no funil', get: (d, stages) => stages.find((s) => s.id === d.stage_id)?.nome || STATUS_LABEL[d.status] || '' },
  { key: 'proprietario', label: 'Proprietário', get: (d) => d.owner_nome || '' },
]

function buildExportRows(deals, stages = []) {
  return deals.map((d) => EXPORT_COLUMNS.map((col) => col.get(d, stages)))
}

const escapeCsv = (value) => `"${String(value).replace(/"/g, '""')}"`

// ';' + BOM: o Excel pt-BR abre acentos e colunas corretamente.
export function toCsv(deals, stages) {
  const header = EXPORT_COLUMNS.map((c) => c.label)
  const lines = buildExportRows(deals, stages).map((row) => row.map((v, i) => (
    EXPORT_COLUMNS[i].key === 'valor' ? escapeCsv(String(v).replace('.', ',')) : escapeCsv(v)
  )))
  return '﻿' + [header.map(escapeCsv), ...lines].map((l) => l.join(';')).join('\r\n')
}

export function toJson(deals, stages) {
  const rows = buildExportRows(deals, stages).map((row) => Object.fromEntries(row.map((v, i) => [EXPORT_COLUMNS[i].key, v])))
  return JSON.stringify(rows, null, 2)
}

const escapeHtml = (value) => String(value).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))

export function toHtmlTable(deals, stages, title = 'Oportunidades') {
  const head = EXPORT_COLUMNS.map((c) => `<th>${escapeHtml(c.label)}</th>`).join('')
  const body = buildExportRows(deals, stages)
    .map((row) => `<tr>${row.map((v, i) => `<td>${escapeHtml(EXPORT_COLUMNS[i].key === 'valor' ? String(v).replace('.', ',') : v)}</td>`).join('')}</tr>`)
    .join('')
  return `<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(title)}</title>`
    + '<style>body{font-family:Arial,sans-serif;font-size:12px}table{border-collapse:collapse;width:100%}'
    + 'th,td{border:1px solid #ccc;padding:5px 8px;text-align:left}th{background:#f2f4f7}</style></head>'
    + `<body><h2>${escapeHtml(title)}</h2><table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`
}

function download(content, mime, filename) {
  const url = URL.createObjectURL(new Blob([content], { type: mime }))
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

function printAsPdf(html) {
  const frame = document.createElement('iframe')
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0'
  document.body.appendChild(frame)
  const doc = frame.contentWindow.document
  doc.open()
  doc.write(html)
  doc.close()
  frame.contentWindow.onafterprint = () => frame.remove()
  setTimeout(() => { frame.contentWindow.focus(); frame.contentWindow.print() }, 100)
  setTimeout(() => frame.remove(), 60000)
}

// Retorna a mensagem de confirmação exibida ao usuário.
export function exportDeals(format, deals, stages, pipelineName = 'oportunidades') {
  const slug = String(pipelineName).normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase() || 'oportunidades'
  const base = `${slug}-${new Date().toISOString().slice(0, 10)}`
  if (format === 'CSV') download(toCsv(deals, stages), 'text/csv;charset=utf-8;', `${base}.csv`)
  else if (format === 'JSON') download(toJson(deals, stages), 'application/json;charset=utf-8;', `${base}.json`)
  else if (format === 'Excel') download('﻿' + toHtmlTable(deals, stages, pipelineName), 'application/vnd.ms-excel;charset=utf-8;', `${base}.xls`)
  else if (format === 'PDF') printAsPdf(toHtmlTable(deals, stages, pipelineName))
  else return ''
  return `${deals.length} ${deals.length === 1 ? 'oportunidade exportada' : 'oportunidades exportadas'} em ${format}.`
}
